var E = /* @__PURE__ */ ((r) => (r.DOWN = "ArrowDown", r.UP = "ArrowUp", r.RIGHT = "ArrowRight", r.LEFT = "ArrowLeft", r))(E || {}), a = /* @__PURE__ */ ((r) => (r.ESCAPE = "Escape", r.TAB = "Tab", r.ENTER = "Enter", r.SPACE = " ", r))(a || {});
export {
  a as K,
  E as a
};
